import { render, staticRenderFns } from "./houseBlurb.vue?vue&type=template&id=730a5989&scoped=true&"
import script from "./houseBlurb.vue?vue&type=script&lang=js&"
export * from "./houseBlurb.vue?vue&type=script&lang=js&"
import style0 from "./houseBlurb.vue?vue&type=style&index=0&id=730a5989&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "730a5989",
  null
  
)

export default component.exports